import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Tabs,
    Rate,
    Col,
    Popconfirm,
    Image,
    Modal, Badge, message
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {
    PaperClipOutlined,
    LinkOutlined,
    ExclamationCircleFilled,
    SearchOutlined,
    ReloadOutlined, MailOutlined
} from '@ant-design/icons'
import moment from 'moment';
import HtView from '../hetong/view'
import FjView from '../fangjian/view'
import JfView1 from '../jf_fz/view'
import JfView2 from '../jf_wyf/view'
import JfView3 from '../jf_sf/view'
import JfView4 from '../jf_df/view'
import JfView5 from '../jf_zlf/view'
import JfView6 from '../jf_gnf/view'
import CgView from '../caigou/view'
import View from './znxx_view'

const {Option} = Select;
const {RangePicker} = DatePicker;
const {TabPane} = Tabs;

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newcondition: {},
            oldcondition: {},
            list: [],
            tableloading: false,
            selectedRowKeys: [],
            count: 0,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {

    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            setTimeout(this.getdata(1, null))
        } else {
            that.setState({
                condition: {
                    id: this.props.id,
                },

                loading: false
            })
        }
    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.newcondition, {[name]: dateString})
        this.setState({
            newcondition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) => <Option value={item.id} key={index}>{item.name}</Option>)
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(name, dates, dateStrings)
        var data = Object.assign({}, this.state.newcondition, {
            [name + '1']: dateStrings[0], [name + '2']: dateStrings[1]
        })
        if (data) {
            this.setState({
                newcondition: data
            })
        }
    }

    pagechange(page, pagesize) {
        let that = this
        console.log(page, pagesize)
        let data = Object.assign({}, this.state.oldcondition, {current: page, pagesize: pagesize})
        setTimeout(() => {
            this.setState({
                oldcondition: data
            })
            that.getdata(0, null)
        })
    }

    onSelectChange = selectedRowKeys => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({selectedRowKeys});
    };

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    getdata = (subtype = 0, e) => {
        let nav2 = store.getState().data.nav2
        let that = this
        that.setState({
            tableloading: true
        })
        if (subtype == 1) {
            var arr = that.state.newcondition
            let old = that.state.oldcondition
            arr = Object.assign({}, arr, {current: 1, pagesize: old.pagesize})
            that.setState({
                oldcondition: arr
            })
        } else {
            var arr = Object.assign({}, this.state.oldcondition, {})
        }
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        fetch('/Geren/message', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                //
                that.setState({
                    list: data.datalist,
                    type_react: data.type_react ? data.type_react : [],
                    status_react: data.status_react ? data.status_react : [],
                    tableloading: false,
                    count: Number(data.count)
                })
            })
    }

    reset() {
        let that = this
        that.setState({
            newcondition: {}, oldcondition: {},
        })
        setTimeout(() => {
            that.getdata(1, null)
        })
    }

    yidu() {
        let that = this
        fetch('/Geren/messageSave', {
            method: "POST", body: JSON.stringify({
                'id': this.state.selectedRowKeys,
                edit: 2
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg)
                    return
                }
                this.pagechange(1, this.state.oldcondition.pagesize)
                that.setState({
                    selectedRowKeys: []
                })
            })
    }

    render() {
        const columns = [
            {
                title: '状态',
                dataIndex: 'status_text',
                key: 'status_text',
                width: 100,
                render: (row, record) => {
                    return (<>
                        {record.status == 0 ? <Tag color={'red'}>{row}</Tag> : null}
                        {record.status == 1 ? <Tag color={'green'}>{row}</Tag> : null}
                    </>)
                }
            }, {
                title: '标题',
                dataIndex: 'title',
                key: 'title',
                width: 250,
                render: (row, record) => {
                    return (<>
                        <View id={record.id} title={row} refresh={this.getdata.bind(this)}/>
                    </>)
                }
            }, {
                title: '提醒内容',
                dataIndex: 'content',
                key: 'content',
            },
            /*{
                title: '快捷跳转',
                dataIndex: 'uptitle',
                key: 'uptitle',
                render: (row, record) => {
                    return (<>
                        {/!*合同*!/}
                        {record.type == 1 && <>
                            <HtView id={record.upid} title={row} refresh={this.getdata.bind(this)}/>
                        </>}
                        {/!*房间*!/}
                        {record.type == 2 && <>
                            <FjView id={record.upid} title={row} refresh={this.getdata.bind(this)}/>
                        </>}
                        {/!*缴费*!/}
                        {record.type == 3 && <>
                            {record.type2 == 1 && <JfView1 id={record.upid} title={row} refresh={this.getdata.bind(this)}/>}
                            {record.type2 == 2 && <JfView2 id={record.upid} title={row} refresh={this.getdata.bind(this)}/>}
                            {record.type2 == 3 && <JfView3 id={record.upid} title={row} refresh={this.getdata.bind(this)}/>}
                            {record.type2 == 4 && <JfView4 id={record.upid} title={row} refresh={this.getdata.bind(this)}/>}
                            {record.type2 == 5 && <JfView5 id={record.upid} title={row} refresh={this.getdata.bind(this)}/>}
                            {record.type2 == 6 && <JfView6 id={record.upid} title={row} refresh={this.getdata.bind(this)}/>}
                        </>}
                        {/!*采购*!/}
                        {record.type == 4 && <>
                            <CgView id={record.upid} title={row} refresh={this.getdata.bind(this)}/>
                        </>}
                    </>)
                },
            }, */
            {
                title: '提醒时间',
                dataIndex: 'dateline',
                key: 'dateline',
                width: 180
            }
        ]
        const {tableloading, selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys, onChange: this.onSelectChange.bind(this), // hideSelectAll: true,
            preserveSelectedRowKeys: false,
        };
        const hasSelected = selectedRowKeys.length > 0;
        return (<>
            <a onClick={this.mdchange.bind(this)}>
                <Badge
                    count={store.getState().data.jiaobiao ? store.getState().data.jiaobiao.num : 0}
                    size="small" offset={[0, 0]} overflowCount={99999}>
                    <MailOutlined className={'pic'}/>
                </Badge>
            </a>
            <Modal title="站内信" maskClosable={false} destroyOnClose={true} width={1200}
                   visible={this.state.visible} onCancel={this.mdchange.bind(this)} footer={null}>
                <Row justify="space-between" align="top" style={{marginBottom: 15}}>
                    <Space wrap>
                        <Input className="input" placeholder="请输入搜索内容"
                               value={this.state.newcondition.keywords ? this.state.newcondition.keywords : null}
                               onChange={this.onChange.bind(this, 'keywords')} autoComplete="off"/>
                        <Select placeholder="状态"
                                style={{width: 120}}
                                value={this.state.newcondition.status ? this.state.newcondition.status : null}
                                onChange={this.onSelChange.bind(this, 'status')} allowClear>
                            {this.arrsel(this.state.status_react)}
                        </Select>
                        <Select placeholder="类型"
                                style={{width: 120}}
                                value={this.state.newcondition.type ? this.state.newcondition.type : null}
                                onChange={this.onSelChange.bind(this, 'type')} allowClear showSearch
                                optionFilterProp="children">
                            {this.arrsel(this.state.type_react)}
                        </Select>
                        <RangePicker allowEmpty={[true, true]} onChange={this.onRangeChange.bind(this, 'addtime')}
                                     value={[(this.state.newcondition.addtime1 ? moment(this.state.newcondition.addtime1) : null), (this.state.newcondition.addtime2 ? moment(this.state.newcondition.addtime2) : null)]}
                                     placeholder={['时间范围', '时间范围']}/>
                        <Button type="primary" icon={<SearchOutlined/>}
                                onClick={this.getdata.bind(this, 1)}>查询</Button>
                        <Button type="primary" icon={<ReloadOutlined/>} className='huise'
                                onClick={this.reset.bind(this)}>重置</Button>
                    </Space>
                </Row>
                <Table
                    bordered
                    columns={columns}
                    dataSource={this.state.list}
                    pagination={false}
                    loading={tableloading}
                    rowSelection={rowSelection}
                    className='table'
                    // scroll={{x: 2500}}
                    style={{marginBottom: 20}}
                />
                <Row justify={'space-between'}>
                    <div className='l'>
                        <Space wrap>
                            {hasSelected ? <>
                                <Button type="primary" onClick={() => this.yidu()} danger>已读</Button>
                            </> : null}
                        </Space>
                    </div>
                    <Pagination showQuickJumper
                                current={this.state.oldcondition.current ? this.state.oldcondition.current : 1}
                                pageSize={this.state.oldcondition.pagesize ? this.state.oldcondition.pagesize : 10}
                                total={this.state.count} onChange={this.pagechange.bind(this)} showSizeChanger={true}
                                showTotal={total => `共 ${total} 条数据`}/>
                </Row>
            </Modal>
        </>)
    }
}

export default Index
